(() => {
  const initialize = (scope) => {
    scope.querySelectorAll('.sbc-tabs-wrap, .tlc-tabs-wrap').forEach((strip) => {
      if (strip.dataset.navigationReady) return;
      strip.dataset.navigationReady = 'true';
      const scroller = strip.querySelector('[role="tablist"]');
      const previous = strip.querySelector('.sbc-tabs-arrow-left, .tlc-tabs-arrow-left');
      const next = strip.querySelector('.sbc-tabs-arrow-right, .tlc-tabs-arrow-right');
      if (!scroller || !previous || !next) return;
      const tabs = [...scroller.querySelectorAll('[role="tab"]')];
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const centerActive = () => {
        const active = scroller.querySelector('[aria-selected="true"]');
        if (!active) return;
        const tabBounds = active.getBoundingClientRect();
        const stripBounds = scroller.getBoundingClientRect();
        const behavior = scroller.style.scrollBehavior;
        scroller.style.scrollBehavior = 'auto';
        scroller.scrollLeft += tabBounds.left - stripBounds.left - (scroller.clientWidth - tabBounds.width) / 2;
        scroller.style.scrollBehavior = behavior;
      };
      const update = () => {
        strip.classList.toggle('has-overflow', scroller.scrollWidth > scroller.clientWidth + 2);
        previous.disabled = scroller.scrollLeft < 2;
        next.disabled = scroller.scrollLeft + scroller.clientWidth >= scroller.scrollWidth - 2;
      };
      const scroll = (direction) => {
        scroller.scrollBy({ left: direction * Math.max(scroller.clientWidth * .7, 180), behavior: reducedMotion.matches ? 'auto' : 'smooth' });
      };
      previous.addEventListener('click', () => scroll(-1));
      next.addEventListener('click', () => scroll(1));
      scroller.addEventListener('scroll', update, { passive: true });
      tabs.forEach((tab) => { tab.tabIndex = tab.getAttribute('aria-selected') === 'true' ? 0 : -1; });
      scroller.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        const index = tabs.indexOf(document.activeElement);
        if (index === -1) return;
        event.preventDefault();
        const nextIndex = event.key === 'Home' ? 0 : event.key === 'End' ? tabs.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
        tabs[nextIndex].focus({ preventScroll: true });
        tabs[nextIndex].click();
        tabs[nextIndex].scrollIntoView({ block: 'nearest', inline: 'center', behavior: reducedMotion.matches ? 'auto' : 'smooth' });
      });
      let drag = null;
      let suppressClick = false;
      scroller.addEventListener('pointerdown', (event) => {
        suppressClick = false;
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        drag = { x: event.clientX, scroll: scroller.scrollLeft, pointer: event.pointerId, moved: false };
      });
      scroller.addEventListener('pointermove', (event) => {
        if (!drag || event.pointerId !== drag.pointer) return;
        const delta = event.clientX - drag.x;
        if (!drag.moved && Math.abs(delta) > 6) {
          drag.moved = true;
          scroller.setPointerCapture(event.pointerId);
          scroller.classList.add('is-dragging');
        }
        if (!drag.moved) return;
        event.preventDefault();
        scroller.scrollLeft = drag.scroll - delta;
      });
      const finish = (event) => {
        if (!drag || event.pointerId !== drag.pointer) return;
        suppressClick = drag.moved;
        if (scroller.hasPointerCapture(event.pointerId)) scroller.releasePointerCapture(event.pointerId);
        scroller.classList.remove('is-dragging');
        drag = null;
      };
      scroller.addEventListener('pointerup', finish);
      scroller.addEventListener('pointercancel', finish);
      scroller.addEventListener('pointerleave', (event) => { if (drag && !drag.moved) finish(event); });
      scroller.addEventListener('click', (event) => {
        if (!suppressClick) return;
        suppressClick = false;
        event.preventDefault();
        event.stopImmediatePropagation();
      }, true);
      let lastWidth = 0;
      const observer = new ResizeObserver(() => {
        if (scroller.clientWidth !== lastWidth) {
          lastWidth = scroller.clientWidth;
          centerActive();
        }
        update();
      });
      observer.observe(scroller);
      centerActive();
      update();
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
